import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './components/Header/Header';
import FooterSection from './components/Footer/FooterSection';
import Home from './pages/Home';
import Menu from './components/Menu/Menu';
import Contact from './pages/Contact';
import RentalSection from './components/Rental/RentalSection';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/rental" element={<RentalSection />} />
          </Routes>
        </main>
        <FooterSection />
      </div>
    </Router>
  );
}